import React from "react";
import Loader from "./assets/loader.gif";

const FullPageLoader = ({ progress }) => {
  return (
    <>
      <div className="loading-overlay">
        <div className="is-active">
          <span className="loadingtxt">
            <img className="loadingImg" src={Loader} alt="loader" />
            We are preparing your images!
          </span>
        </div>
      </div>
    </>
  );
};

export default FullPageLoader;
